export const cancelAppointmentLoading = ({store}) => store.cancelAppointmentReducer.loading;

export const cancelAppointmentError =  ({store})  => store.cancelAppointmentReducer.error;

export const cancelAppointmentData =  ({store})  => store.cancelAppointmentReducer.data;